/* @flow */

import * as types from 'src/shared/domain/user/action/userActionTypes';
import * as namespaces from 'src/shared/domain/user/action/userActionNamespaces';
import * as authenticationTypes from 'src/shared/app/authentication/action/base/authenticationActionTypes';
import * as signupTypes from 'src/shared/app/signup/action/signupActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = null;

const reset = () => null;

const _setUserWithNamespace = (state: number, action: Object) => {
  const { namespace } = action;

  if (namespace === namespaces.SELF) {
    return action.result;
  }
  return state;
};

const _setUser = (state: number, action: Object) => action.userId;

export default createReducer(initialState, {
  [types.FETCH_USER_SUCCESS]: _setUserWithNamespace,
  [types.RESET_USER]: reset,
  [authenticationTypes.LOGIN_SUCCESS]: _setUser,
  [signupTypes.SIGNUP_CREATE_USER_SUCCESS]: _setUser,
  [authenticationTypes.CREATE_PASSWORD_SUCCESS]: _setUser,
  [authenticationTypes.RESET_PASSWORD_SUCCESS]: _setUser,
});
